import React from 'react'
import './styles.css'
import 'animate.css/animate.min.css'

export default ({
  children,
}) => <div id='layout-wrapper'>{children}</div>
